var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"wrapper"},[(+_vm.configInfo.closeWeb !== 1)?[(_vm.$route.path === '/index')?[_c('guide-page',{ref:"guidePage"})]:_vm._e(),_c('t-top-nav'),_c('router-view'),_c('t-foot-info')]:[_c('close')]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }